import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Coupon from './Coupon';
import CheckoutSummary from './CheckoutSummary';
import { STEP_PRODUCTS, STEP_CHECKOUT, STEP_ROOMS } from '../../../helpers/steps';

const Sidebar = props => {

  const application = useSelector(state => state.application);
  const { widget } = application;
  const isWidget = widget ===  '1';

  const {
    page,
    reservation,
    submitButtonReleased,
    canSendReservation,
    onSendReservation,
  } = props;
  let { showCoupon, showCheckoutSummary } = props;

  if (!reservation) {
    showCoupon = false;
    showCheckoutSummary = false;
  }

  const sidebarStyles = isWidget ? { marginTop: `-4rem` } : {};
  const stickyMargin = (page === STEP_PRODUCTS || page === STEP_CHECKOUT) ? '-1.5rem' : '-4rem';

  return (
    <div className={`col-12 col-md-3 mb-3 sidebar${page === STEP_ROOMS ? ' sidebar--rooms' : ''}`} style={sidebarStyles}>
      <div className="summary-sticky" style={{ marginTop: stickyMargin }}>
        {showCheckoutSummary && (
          <div className="card mb-3">
            <CheckoutSummary
              submitButtonReleased={submitButtonReleased}
              canSendReservation={canSendReservation}
              onSendReservation={onSendReservation}
            />
          </div>
        )}

        {showCoupon && (
          <div className="card mb-3 cupom">
            <Coupon reservation={reservation} />
          </div>
        )}
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  page: PropTypes.string,
  showCoupon: PropTypes.bool,
  showCheckoutSummary: PropTypes.bool,
  reservation: PropTypes.object,
  canSendReservation: PropTypes.bool,
  onSendReservation: PropTypes.func,
};

export default Sidebar;
